export const provinceData = {
	'RECORDS': [
		{
			'id': '340000',
			'name': '安徽省',
			'areacode': 'YGS0006',
			'areaname': '华东区',
			'pid': '100000',
			'shortname': '安徽',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,安徽省',
			'lng': '117.283042',
			'lat': '31.86119',
			'pinyin': 'Anhui',
			'initial': 'A'
		},
		{
			'id': '110000',
			'name': '北京',
			'areacode': 'YGS0001',
			'areaname': '华北区',
			'pid': '100000',
			'shortname': '北京',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,北京',
			'lng': '116.405285',
			'lat': '39.904989',
			'pinyin': 'Beijing',
			'initial': 'B'
		},
		{
			'id': '500000',
			'name': '重庆',
			'areacode': 'YGS0005',
			'areaname': '西南区',
			'pid': '100000',
			'shortname': '重庆',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,重庆',
			'lng': '106.504962',
			'lat': '29.533155',
			'pinyin': 'Chongqing',
			'initial': 'C'
		},
		{
			'id': '350000',
			'name': '福建省',
			'areacode': 'YGS0006',
			'areaname': '华东区',
			'pid': '100000',
			'shortname': '福建',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,福建省',
			'lng': '119.306239',
			'lat': '26.075302',
			'pinyin': 'Fujian',
			'initial': 'F'
		},
		{
			'id': '440000',
			'name': '广东省',
			'areacode': 'YGS0007',
			'areaname': '华南区',
			'pid': '100000',
			'shortname': '广东',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,广东省',
			'lng': '113.280637',
			'lat': '23.125178',
			'pinyin': 'Guangdong',
			'initial': 'G'
		},
		{
			'id': '450000',
			'name': '广西壮族自治区',
			'areacode': 'YGS0007',
			'areaname': '华南区',
			'pid': '100000',
			'shortname': '广西',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,广西壮族自治区',
			'lng': '108.320004',
			'lat': '22.82402',
			'pinyin': 'Guangxi',
			'initial': 'G'
		},
		{
			'id': '520000',
			'name': '贵州省',
			'areacode': 'YGS0005',
			'areaname': '西南区',
			'pid': '100000',
			'shortname': '贵州',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,贵州省',
			'lng': '106.713478',
			'lat': '26.578343',
			'pinyin': 'Guizhou',
			'initial': 'G'
		},
		{
			'id': '620000',
			'name': '甘肃省',
			'areacode': 'YGS0003',
			'areaname': '西北区',
			'pid': '100000',
			'shortname': '甘肃',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,甘肃省',
			'lng': '103.823557',
			'lat': '36.058039',
			'pinyin': 'Gansu',
			'initial': 'G'
		},
		{
			'id': '130000',
			'name': '河北省',
			'areacode': 'YGS0001',
			'areaname': '华北区',
			'pid': '100000',
			'shortname': '河北',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,河北省',
			'lng': '114.502461',
			'lat': '38.045474',
			'pinyin': 'Hebei',
			'initial': 'H'
		},
		{
			'id': '230000',
			'name': '黑龙江省',
			'areacode': 'YGS0002',
			'areaname': '东北区',
			'pid': '100000',
			'shortname': '黑龙江',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,黑龙江省',
			'lng': '126.642464',
			'lat': '45.756967',
			'pinyin': 'Heilongjiang',
			'initial': 'H'
		},
		{
			'id': '410000',
			'name': '河南省',
			'areacode': 'YGS0004',
			'areaname': '华中区',
			'pid': '100000',
			'shortname': '河南',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,河南省',
			'lng': '113.665412',
			'lat': '34.757975',
			'pinyin': 'Henan',
			'initial': 'H'
		},
		{
			'id': '420000',
			'name': '湖北省',
			'areacode': 'YGS0004',
			'areaname': '华中区',
			'pid': '100000',
			'shortname': '湖北',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,湖北省',
			'lng': '114.298572',
			'lat': '30.584355',
			'pinyin': 'Hubei',
			'initial': 'H'
		},
		{
			'id': '430000',
			'name': '湖南省',
			'areacode': 'YGS0004',
			'areaname': '华中区',
			'pid': '100000',
			'shortname': '湖南',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,湖南省',
			'lng': '112.982279',
			'lat': '28.19409',
			'pinyin': 'Hunan',
			'initial': 'H'
		},
		{
			'id': '460000',
			'name': '海南省',
			'areacode': 'YGS0007',
			'areaname': '华南区',
			'pid': '100000',
			'shortname': '海南',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,海南省',
			'lng': '110.33119',
			'lat': '20.031971',
			'pinyin': 'Hainan',
			'initial': 'H'
		},
		{
			'id': '150000',
			'name': '内蒙古自治区',
			'areacode': 'YGS0001',
			'areaname': '华北区',
			'pid': '100000',
			'shortname': '内蒙古',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,内蒙古自治区',
			'lng': '111.670801',
			'lat': '40.818311',
			'pinyin': 'Inner Mongolia',
			'initial': 'I'
		},
		{
			'id': '220000',
			'name': '吉林省',
			'areacode': 'YGS0002',
			'areaname': '东北区',
			'pid': '100000',
			'shortname': '吉林',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,吉林省',
			'lng': '125.3245',
			'lat': '43.886841',
			'pinyin': 'Jilin',
			'initial': 'J'
		},
		{
			'id': '320000',
			'name': '江苏省',
			'areacode': 'YGS0006',
			'areaname': '华东区',
			'pid': '100000',
			'shortname': '江苏',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,江苏省',
			'lng': '118.767413',
			'lat': '32.041544',
			'pinyin': 'Jiangsu',
			'initial': 'J'
		},
		{
			'id': '360000',
			'name': '江西省',
			'areacode': 'YGS0004',
			'areaname': '华中区',
			'pid': '100000',
			'shortname': '江西',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,江西省',
			'lng': '115.892151',
			'lat': '28.676493',
			'pinyin': 'Jiangxi',
			'initial': 'J'
		},
		{
			'id': '210000',
			'name': '辽宁省',
			'areacode': 'YGS0002',
			'areaname': '东北区',
			'pid': '100000',
			'shortname': '辽宁',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,辽宁省',
			'lng': '123.429096',
			'lat': '41.796767',
			'pinyin': 'Liaoning',
			'initial': 'L'
		},
		{
			'id': '640000',
			'name': '宁夏回族自治区',
			'areacode': 'YGS0003',
			'areaname': '西北区',
			'pid': '100000',
			'shortname': '宁夏',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,宁夏回族自治区',
			'lng': '106.278179',
			'lat': '38.46637',
			'pinyin': 'Ningxia',
			'initial': 'N'
		},
		{
			'id': '630000',
			'name': '青海省',
			'areacode': 'YGS0003',
			'areaname': '西北区',
			'pid': '100000',
			'shortname': '青海',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,青海省',
			'lng': '101.778916',
			'lat': '36.623178',
			'pinyin': 'Qinghai',
			'initial': 'Q'
		},
		{
			'id': '140000',
			'name': '山西省',
			'areacode': 'YGS0001',
			'areaname': '华北区',
			'pid': '100000',
			'shortname': '山西',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,山西省',
			'lng': '112.549248',
			'lat': '37.857014',
			'pinyin': 'Shanxi',
			'initial': 'S'
		},
		{
			'id': '310000',
			'name': '上海',
			'areacode': 'YGS0006',
			'areaname': '华东区',
			'pid': '100000',
			'shortname': '上海',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,上海',
			'lng': '121.472644',
			'lat': '31.231706',
			'pinyin': 'Shanghai',
			'initial': 'S'
		},
		{
			'id': '370000',
			'name': '山东省',
			'areacode': 'YGS0006',
			'areaname': '华东区',
			'pid': '100000',
			'shortname': '山东',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,山东省',
			'lng': '117.000923',
			'lat': '36.675807',
			'pinyin': 'Shandong',
			'initial': 'S'
		},
		{
			'id': '510000',
			'name': '四川省',
			'areacode': 'YGS0005',
			'areaname': '西南区',
			'pid': '100000',
			'shortname': '四川',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,四川省',
			'lng': '104.065735',
			'lat': '30.659462',
			'pinyin': 'Sichuan',
			'initial': 'S'
		},
		{
			'id': '610000',
			'name': '陕西省',
			'areacode': 'YGS0003',
			'areaname': '西北区',
			'pid': '100000',
			'shortname': '陕西',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,陕西省',
			'lng': '108.948024',
			'lat': '34.263161',
			'pinyin': 'Shaanxi',
			'initial': 'S'
		},
		{
			'id': '120000',
			'name': '天津',
			'areacode': 'YGS0001',
			'areaname': '华北区',
			'pid': '100000',
			'shortname': '天津',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,天津',
			'lng': '117.190182',
			'lat': '39.125596',
			'pinyin': 'Tianjin',
			'initial': 'T'
		},
		{
			'id': '540000',
			'name': '西藏自治区',
			'areacode': 'YGS0005',
			'areaname': '西南区',
			'pid': '100000',
			'shortname': '西藏',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,西藏自治区',
			'lng': '91.132212',
			'lat': '29.660361',
			'pinyin': 'Tibet',
			'initial': 'T'
		},
		{
			'id': '650000',
			'name': '新疆维吾尔自治区',
			'areacode': 'YGS0003',
			'areaname': '西北区',
			'pid': '100000',
			'shortname': '新疆',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,新疆维吾尔自治区',
			'lng': '87.617733',
			'lat': '43.792818',
			'pinyin': 'Xinjiang',
			'initial': 'X'
		},
		{
			'id': '530000',
			'name': '云南省',
			'areacode': 'YGS0005',
			'areaname': '西南区',
			'pid': '100000',
			'shortname': '云南',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,云南省',
			'lng': '102.712251',
			'lat': '25.040609',
			'pinyin': 'Yunnan',
			'initial': 'Y'
		},
		{
			'id': '330000',
			'name': '浙江省',
			'areacode': 'YGS0006',
			'areaname': '华东区',
			'pid': '100000',
			'shortname': '浙江',
			'leveltype': 1,
			'citycode': null,
			'zipcode': null,
			'mergername': '中国,浙江省',
			'lng': '120.153576',
			'lat': '30.287459',
			'pinyin': 'Zhejiang',
			'initial': 'Z'
		}
	]
}
